import { render } from "./FeatureComponent.vue?vue&type=template&id=47074d70&scoped=true"
import script from "./FeatureComponent.vue?vue&type=script&lang=js"
export * from "./FeatureComponent.vue?vue&type=script&lang=js"

import "./FeatureComponent.vue?vue&type=style&index=0&id=47074d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47074d70"]])

export default __exports__